import "./tag.scss";

export interface TagProps {
  label: string;
  spacing?: boolean;
}

export const Tag = ({ label, spacing }: TagProps) => {
  return (
    <span className="tag-container" style={{ marginLeft: spacing ? 8 : 0 }}>
      <span className="ellipse">
        <span className="tag-text">{label}</span>
      </span>
    </span>
  );
};
